// extracted by mini-css-extract-plugin
export default {"desktopLogo":"GlobalHeaderLogo-module__desktopLogo___28CIh","mobileLogo":"GlobalHeaderLogo-module__mobileLogo___pe3WT"};